/**
 * Rapporten, slik appen bruker den.
 *
 * ========  BYGGEREN LIGGER I `packages/shared/rapport`  ========
 *
 * Flyttet dit 02.11.2026, da nettflata ogsaa skulle kunne avslutte dagen.
 * To byggere for samme dokument er to dokumenter, og redaktoeren skal ikke
 * kunne se hvilken flate rapporten ble laget paa.
 *
 * DET SOM BLIR IGJEN HER er delingsarket: `navigator.share` er telefonens,
 * og den brukes bare paa en PRIVAT logg — en produksjonsrapport leveres til
 * produksjonen og deles ikke av regi. Se CLAUDE.md.
 */
export {
  generateReport,
  type GeneratedReport,
  type ReportInput,
} from "@infoflyt/shared/rapport";
import type { GeneratedReport } from "@infoflyt/shared/rapport";

/**
 * Deler rapporten gjennom systemets delingsark.
 *
 * Rapporten SKAL forlate appen — det er hele poenget med den. Det er
 * dokumentene (dagsmanus, dagsplan, kjøreplan) som aldri får gjøre det.
 * Se docs/12-ui-feltapp.md.
 */
export async function shareReport(report: GeneratedReport): Promise<"shared" | "downloaded"> {
  const file = new File([report.blob], report.filename, { type: "application/pdf" });

  if (typeof navigator.canShare === "function" && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: report.filename });
    return "shared";
  }

  // Ingen delingsark: last ned i stedet, slik at rapporten uansett kommer ut.
  const url = URL.createObjectURL(report.blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = report.filename;
  /*
   * Lenka maa staa i dokumentet, og adressen maa leve til nedlastingen er
   * i gang. Frigjorde vi den i samme oppgave som klikket, avbroet WebKit
   * nedlastingen — rapporten kom aldri ut.
   */
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  window.setTimeout(() => {
    a.remove();
    URL.revokeObjectURL(url);
  }, 1000);
  return "downloaded";
}
